import { api } from 'components/api'
import { inboxConversationsPath } from 'components/routes/api'
import type {
  ApiInboxConversationsIndexResponse,
  InboxConversationSummary
} from '../inboxTypes'
import { mapApiSummaryToInboxSummary } from '../inboxTypes'

export const fetchInboxConversations = async (
  reviewId?: number,
  additionalParticipantIds?: number[],
  exactParticipantMatch = false
): Promise<InboxConversationSummary[]> => {
  const response = await api.get<unknown, ApiInboxConversationsIndexResponse>({
    url: inboxConversationsPath(),
    headers: { Accept: 'application/json' },
    cacheOptions: { enabled: false },
    ...((reviewId == null && additionalParticipantIds == null && !exactParticipantMatch)
      ? {}
      : {
          params: {
            ...(reviewId == null ? {} : { review_id: reviewId }),
            ...(additionalParticipantIds == null ? {} : { additional_participant_ids: additionalParticipantIds }),
            ...(exactParticipantMatch ? { exact_participant_match: true } : {})
          }
        })
  })
  if (response.data.conversations == null) {
    throw new Error('Inbox conversations response is missing conversations')
  }

  return response.data.conversations.map(mapApiSummaryToInboxSummary)
}
